/**
 * Beta feedback layer — validated config + helpers (Epic 25, Story 25.1).
 *
 * Importing this module validates the shipped config against
 * `FeedbackConfigSchema` and **throws fail-loud** on a malformed edit, so a
 * typo in `feedback-config.ts` surfaces at build/startup rather than shipping
 * silently. Consumers import the validated `feedbackConfig` (and
 * `deriveSeverity`) via `@sagamoon/shared`.
 *
 * The web app is the only consumer (Option A — no Cloud Function).
 *
 * @module feedback
 */

import { FeedbackConfigSchema } from '../schemas/feedback-schemas';
import type { FeedbackConfig } from '../types/feedback';
import { feedbackConfigData } from './feedback-config';

const parsed = FeedbackConfigSchema.safeParse(feedbackConfigData);
if (!parsed.success) {
  throw new Error(
    `Invalid feedback-config: ${parsed.error.issues
      .map((i) => `${i.path.join('.')}: ${i.message}`)
      .join('; ')}`
  );
}

/** The validated, ready-to-use feedback config (cadence, questions, severity). */
export const feedbackConfig: FeedbackConfig = feedbackConfigData;

export { deriveSeverity } from './derive-severity';
